import React, { useRef, useState, useEffect } from "react";
import { Box, Chip, IconButton } from "@mui/material";
import StatusMenu from "../menu/StatusMenu";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { StatusTypes as StatusEnum } from '../../enums/StatusEnum';
import { PriorityTypes } from '../../enums/PriorityEnum';
import styles from '../../styles/tags/index.module.scss';

const STATUS_STYLES = {
  Pass: { label: 'Pass', bgcolor: '#F7FFC8', color: '#7E9B08', fontWeight: 'normal', borderRadius: '5px' },
  Passed: { label: 'Passed', bgcolor: '#F7FFC8', color: '#7E9B08', fontWeight: 'normal', borderRadius: '5px' },
  Failed: { label: 'Failed', bgcolor: '#FFF4F6', color: '#F66868', fontWeight: 'normal', borderRadius: '5px' },
  Pending: { label: 'Pending', bgcolor: '#0000000A', color: '#0000007A', fontWeight: 'normal', borderRadius: '5px' },
  Skipped: { label: 'Skipped', bgcolor: '#FFF6BF', color: '#E4B304', fontWeight: 'normal', borderRadius: '5px' },
  Fail: { label: 'Fail', bgcolor: '#FFF4F6', color: '#F66868', fontWeight: 'normal', borderRadius: '5px' },
  'Not Executed': { label: 'Not Executed', bgcolor: '#0000000A', color: '#0000007A', fontWeight: 'normal', borderRadius: '5px' },
  [StatusEnum.NEW]: { label: StatusEnum.NEW, bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  [StatusEnum.INREVIEW]: { label: StatusEnum.INREVIEW, bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  [StatusEnum.ACTIVE]: { label: StatusEnum.ACTIVE, bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  [StatusEnum.REJECTED]: { label: StatusEnum.REJECTED, bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  [StatusEnum.RETIRED]: { label: StatusEnum.RETIRED, bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  [PriorityTypes.HIGH]: { label: PriorityTypes.HIGH, bgcolor: '#E3F2FD', color: 'rgb(30 64 175 / var(--tw-text-opacity, 1))', fontWeight: 'normal', borderRadius: '5px' },
  [PriorityTypes.NORMAL]: { label: PriorityTypes.NORMAL, bgcolor: '#E3F2FD', color: 'rgb(30 64 175 / var(--tw-text-opacity, 1))', fontWeight: 'normal', borderRadius: '5px' },
  [PriorityTypes.LOW]: { label: PriorityTypes.LOW, bgcolor: '#E3F2FD', color: 'rgb(30 64 175 / var(--tw-text-opacity, 1))', fontWeight: 'normal', borderRadius: '5px' },
  Inprogress: { label: 'In Progress', bgcolor: '#dbeafe', color: '#2563eb', fontWeight: 'normal', borderRadius: '5px' },
  Aborted: { label: 'Aborted', bgcolor: '#fef9c3', color: '#ca8a04', fontWeight: 'normal', borderRadius: '5px' },
  // Role-specific styles
  'Default': { label: 'Default', bgcolor: '#F7FFC8', color: 'green', fontWeight: 'normal', borderRadius: '5px' },
  'Organization': { label: 'Organization', bgcolor: '#F5F5F5', color: 'grey', fontWeight: 'normal', borderRadius: '5px' },
  // Test Group specific styles
  'Static': { label: 'Static', bgcolor: '#E0E7FF', color: '#1D4ED8', fontWeight: 'normal', borderRadius: '5px' },
  'Dynamic': { label: 'Dynamic', bgcolor: '#F3E8FF', color: '#9333EA', fontWeight: 'normal', borderRadius: '5px' },
  'Yes': { label: 'Yes', bgcolor: '#DCFCE7', color: '#16A34A', fontWeight: 'normal', borderRadius: '5px' },
  'No': { label: 'No', bgcolor: '#F3F4F6', color: '#64748B', fontWeight: 'normal', borderRadius: '5px' },
};

const getStatusStyle = (status) => {
  return STATUS_STYLES[status] || { label: status, bgcolor: '#0000000A', color: '#0000007A' };
};

// Helper function to determine role type based on org_id (for roles components)
export const getRoleTypeTag = (org_id) => {
  return org_id === null ? 'Default' : 'Organization';
};

const TagsComponent = ({ tag = '', options=[], value='', handleOptionChange, isMenu=false }) => {
  const [selectedStatus, setSelectedStatus] = useState(value);
  useEffect(() => {
    setSelectedStatus(value);
  }, [value]);
  const { label=tag, bgcolor, color, fontWeight, borderRadius } = getStatusStyle(tag);
  const [showMenu, setShowMenu] = useState(false);
  const chipRef = useRef(null); 

  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  const handleStatusChange = (newStatus) => {
    setSelectedStatus(newStatus);
    handleOptionChange(newStatus);
  };

  return (
    <>
      <button onClick={toggleMenu} ref={chipRef} className={isMenu ? "flex w-full justify-between items-center cursor-default" : "cursor-default"}>
        <Chip
            label={label}
            size="small"
            variant="tagChip"
            className={styles['chip-container']}
            sx={{
              backgroundColor: bgcolor,
              color,
              borderRadius: 10 || borderRadius,
              cursor: 'default !important',
            }}
          />
          {isMenu && <IconButton>
            {showMenu ? <ChevronUpIcon className="icon" /> : <ChevronDownIcon className="icon" />}
          </IconButton>}
      </button>

      {isMenu && showMenu && 
        <StatusMenu
          statuses={options}
          initialStatus={selectedStatus}
          onStatusChange={handleStatusChange}
          anchorEl={chipRef.current}
          onClose={toggleMenu} 
        />
      }
    </>
  );
};

export default TagsComponent;
